// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"9b752418","387":"cd87fa2a","488":"603e9ae6","525":"0fa2cfc1","985":"8e7fa5bd"}[chunkId] + ".chunk.css";
};